<script lang="ts">
    import { defineCustomElement as advCookie } from '@didi/adv-ui/adv-cookie-notice';
    import { onMount, createEventDispatcher } from 'svelte';

    import { cookieHeight, isCookiesShow, omegaParams } from '../store/index';

    export let id = 'CookieConsent';
    export let width = '450';
    export let opacity = '0.9';
    export let bid = 'creditcard';

    const dispatch = createEventDispatcher();

    let cookieElement: HTMLElement;

    onMount(() => {
        advCookie();
    });

    const handleShowCookieState = (event: CustomEvent) => {
        $isCookiesShow = event.detail;
        dispatch('showCookieState', event.detail);
    };

    const handleCookieHeight = (event: CustomEvent) => {
        $cookieHeight = event.detail;
        dispatch('cookieConsentHeight', event.detail);
    };

</script>

<adv-cookie-notice
    bind:this={cookieElement}
    {id}
    {width}
    {opacity}
    {bid}
    params={$omegaParams}
    on:showCookieState={handleShowCookieState}
    on:cookieConsentHeight={handleCookieHeight}
></adv-cookie-notice>
